// @flow

export const dashboardRemindersRoute = "/mein-remindme/erinnerungen";

export function reminder() {
  return dashboardRemindersRoute;
}

export default reminder;
